import { ClickAwayListener, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { IDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";
import { CloseGrayIcon } from "../Icon/CloseGrayIcon";
import { ObserveState } from "../StateManagement/ObserveState";

import VariablePicker from "./VariablePicker";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { DataTypes } from "../../rule-engine-core/Common/Data/DataTypes";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

interface VariablePickerProps {
    selected: string | null | undefined;
    requiredType?: DataTypes | ObjectDataDefinition;
    data: DataDefinition;
    allowNewVariable?: boolean;
    onVariableSet: (path: string, def?: IDataDefinition) => void;
    isList?: boolean;
    show: boolean;
    onClose: () => void;
}

export const VariablePickerDialog = (props: VariablePickerProps) => {
    const { show, isList, onVariableSet, allowNewVariable, data, requiredType, selected, onClose } = props;

    let selectedField: IDataDefinition | null = null;

    try {
        selectedField =
            selected && selected !== ""
                ? (DataUtilities.getFieldFromDataDefinitionByName(data.fields, selected) as IDataDefinition)
                : null;
    } catch (e) {}
    if (!show) return null;
    return (
        <ClickAwayListener onClickAway={onClose}>
            <DialogWrapper>
                <ObserveState
                    listenTo={data}
                    properties={["fields"]}
                    control={() => {
                        return (
                            <VariablePicker
                                selected={selected}
                                data={data}
                                onVariableSet={onVariableSet}
                                allowNewVariable={allowNewVariable}
                                renderTitle={() => {
                                    return (
                                        <DialogHeader>
                                            <Typography>{selectedField?.name ?? "Pick Data Name"}</Typography>
                                            <CloseButton
                                                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                                                    event.stopPropagation();
                                                    onClose();
                                                }}
                                                data-testid="close-pick-dialog"
                                            >
                                                <CloseGrayIcon />
                                            </CloseButton>
                                        </DialogHeader>
                                    );
                                }}
                                requiredType={requiredType}
                                isList={isList}
                                notPopup
                                hideInput
                                fullWidth={true}
                            />
                        );
                    }}
                />
            </DialogWrapper>
        </ClickAwayListener>
    );
};
const DialogWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    box-shadow: 0px 6px 8px -2px ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    border-radius: 4px;

    width: 220px;

    padding: 16px;

    z-index: 10;

    .VariablePicker_Content {
        border: none;
        padding: 0;

        .MuiList-root .MuiListSubheader-gutters {
            padding: 0;
        }

        .MuiList-root {
            max-height: 300px;
        }
    }
`;
const DialogHeader = styled.div`
    position: relative;

    .MuiTypography-body1 {
        //styleName: text/Inter SemiBold 12px;

        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0px;
        text-align: left;

        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

        margin-bottom: 6px;
    }
`;

const CloseButton = styled.div`
    position: absolute;

    top: -12px;
    width: 24px;
    height: 24px;
    right: -12px;

    cursor: pointer;
`;
